/**
 * 区分 tagCode（tags.tag_code）
 * 出典：要件書 5.2・F-26（色は TAG_DEFINITIONS）
 */
export const TAG_CODE_VALUES = ['topPriority', 'major', 'midTier', 'newSmall', 'standby'] as const;

export type TagCode = (typeof TAG_CODE_VALUES)[number];

export const TAG_CODE_LABELS: Readonly<Record<TagCode, string>> = {
  topPriority: '最重要顧客',
  major: '主要顧客',
  midTier: '中堅顧客',
  newSmall: '新規・小規模顧客',
  standby: '控顧客',
};
